// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__XcCCH","withUnderline":"style_withUnderline__IRgCB"};